export default __webpack_public_path__ + "static/media/Background_00283.8c0e765b.png";